import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5000";
function BrowseBlog() {
  const [posts, setPosts] = useState([]);
  const [fetchingErr, setFetchingErr] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);

  const categories = useMemo(() => ["software", "ai-ml", "ar", "devops", "iot"], []);

  useEffect(() => {
    const fetchBlogsByCategories = async () => {
      setLoading(true);
      setFetchingErr(null);
      try {
        const blogPromises = categories.map((category) =>
          fetch(`${BASE_URL}/api/blog/getposts?category=${category}`).then((response) => response.json())
        );
        const blogResults = await Promise.all(blogPromises);
        const allBlogs = blogResults.flat();
        // Sort newest first — new blogs appear at the top, not the bottom
        allBlogs.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setPosts(allBlogs);
      } catch (error) {
        setFetchingErr(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogsByCategories();
  }, [categories]);

  const handleDelete = (postId) => {
    fetch(`${BASE_URL}/api/blog/deletepost/${postId}`, { method: "DELETE" })
      .then((response) => {
        if (response.ok) {
          setPosts(posts.filter((post) => post._id !== postId));
          alert("Post Deleted");
        }
      })
      .catch((error) => alert(`Failed to Delete : ${error} `));
  };

  const handleSearch = () => {
    if (posts) {
      return posts.filter((post) =>
        post.title.toLowerCase().includes(searchValue.toLowerCase())
      );
    }
    return [];
  };

  return (
    <div className="container py-4">
      <div className="row mb-4">
        <div className="col-md-6 mx-auto">
          <div className="input-group">
            <input
              type="text"
              className="form-control shadow-sm"
              placeholder="Search Blogs by Title..."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              style={{
                borderRadius: "6px",
                borderColor: "#d0d5dd",
                padding: "0.65rem 0.85rem",
                fontSize: "16px",
                boxShadow: "0 2px 8px rgba(37,99,235,0.07)",
              }}
            />
          </div>
        </div>
      </div>
      <div className="row g-4 justify-content-center">
        {loading ? (
          <div className="col-12 text-center py-5">
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        ) : fetchingErr ? (
          <div className="col-12 text-danger text-center py-5">{fetchingErr}</div>
        ) : (
          <>
            {handleSearch().length > 0 ? (
              handleSearch().map((post) => (
                <div className="col-md-4 d-flex align-items-stretch" key={post._id}>
                  <div className="card h-100 shadow-sm border-0">
                    <div className="position-relative">
                      <img
                        src={post.featureImage}
                        alt="blogimg"
                        className="card-img-top"
                        style={{ height: "200px", objectFit: "cover" }}
                      />
                      <span
                        className="badge bg-primary position-absolute top-0 start-0 m-2 text-capitalize"
                        style={{ fontSize: "0.95rem", padding: "0.5em 1em", opacity: 0.95 }}
                      >
                        {post.category}
                      </span>
                    </div>
                    <div className="card-body d-flex flex-column">
                      <h5 className="card-title mb-2">{post.title}</h5>
                      <div className="d-flex justify-content-end gap-2 mt-auto">
                        <Link to={`/blog/${post._id}`}>
                          <button
                            className="btn btn-outline-primary btn-sm"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Edit"
                          >
                            <i className="bi bi-pencil-square"></i>
                          </button>
                        </Link>
                        <button
                          className="btn btn-outline-danger btn-sm"
                          onClick={() => handleDelete(post._id)}
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Delete"
                        >
                          <i className="bi bi-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : !searchValue && posts.length > 0 ? (
              posts.map((post) => (
                <div className="col-md-4 d-flex align-items-stretch" key={post._id}>
                  <div className="card h-100 shadow-sm border-0">
                    <div className="position-relative">
                      <img
                        src={post.featureImage}
                        alt="blogimg"
                        className="card-img-top"
                        style={{ height: "200px", objectFit: "cover" }}
                      />
                      <span
                        className="badge bg-primary position-absolute top-0 start-0 m-2 text-capitalize"
                        style={{ fontSize: "0.95rem", padding: "0.5em 1em", opacity: 0.95 }}
                      >
                        {post.category}
                      </span>
                    </div>
                    <div className="card-body d-flex flex-column">
                      <h5 className="card-title mb-2">{post.title}</h5>
                      <div className="d-flex justify-content-end gap-2 mt-auto">
                        <Link to={`/blog/${post._id}`}>
                          <button
                            className="btn btn-outline-primary btn-sm"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Edit"
                          >
                            <i className="bi bi-pencil-square"></i>
                          </button>
                        </Link>
                        <button
                          className="btn btn-outline-danger btn-sm"
                          onClick={() => handleDelete(post._id)}
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Delete"
                        >
                          <i className="bi bi-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center mt-5">
                {searchValue ? (
                  <div className="alert alert-warning">Oops! No posts found.</div>
                ) : null}
                {posts.length === 0 ? (
                  <div className="alert alert-info">
                    The post bucket is empty, please create posts.
                  </div>
                ) : null}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default BrowseBlog;
